module.exports = __webpack_public_path__ + "img/lq-logo.3f1c211e.jpg";